import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Keyboard, A11y } from 'swiper/modules';

const init = () => {
    const sliders = document.querySelectorAll('.hero-swiper');
    
    if (sliders.length) {
        sliders.forEach(slider => {
            new Swiper(slider, {
                modules: [Navigation, Pagination, Autoplay, EffectFade, Keyboard, A11y],
                slidesPerView: 1,
                loop: true,
                speed: 1000,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {
                    delay: 50000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.hero?.prev : 'Previous slide',
                    nextSlideMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.hero?.next : 'Next slide',
                    firstSlideMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.hero?.first : 'This is the first slide',
                    lastSlideMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.hero?.last : 'This is the last slide',
                    paginationBulletMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.hero?.pagination : 'Go to slide {{index}}',
                    itemRoleDescriptionMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.hero?.item : 'slide',
                    containerMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.hero?.container : 'Hero Slider',
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: slider.querySelector('.swiper-button-next'),
                    prevEl: slider.querySelector('.swiper-button-prev'),
                },
                on: {
                    init: function () {
                        updateNavColor(this);
                    },
                    slideChange: function () {
                        updateNavColor(this);
                    }
                }
            });
        });
    }
};

const updateNavColor = (swiper) => {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const color = activeSlide.getAttribute('data-color');
    
    if (color) {
        swiper.el.style.setProperty('--pagination-nav-color', color);
    } else {
        swiper.el.style.removeProperty('--pagination-nav-color');
    }
};


export { init };
